import swal from 'sweetalert'
export function addToFavorite(character) {
    return (dispatch, getState) => {
        dispatch({
          type: "ADD_FAVORITE_CHARACTERS",
          character
        });
        swal('Complete', `Successfully added ${character.name} to Favorites `, 'success')
    };
}
